import { VaulDrawerShell } from "../../../components/ui/drawer/VaulDrawerShell";
import React from "react";
import { useHomeData } from "../../home";

const INNER_WRAPPER_STYLE = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
} as const;

type VisitWebToSubscribeProps = {
  drawerOpen: boolean;
  handleDrawerChange: (drawerOpen: boolean) => void;
  setDrawerOpen: (drawerOpen: boolean) => void;
};

export const VisitWebToSubscribeModal = (props: VisitWebToSubscribeProps) => {
  const { isVisible } = useHomeData();

  return (
    <div className={`transition-wrapper ${isVisible ? "fade-in" : ""}`}>
      <div>
        <div className="home-inner-wrapper" style={INNER_WRAPPER_STYLE}>
          <VaulDrawerShell
            open={props.drawerOpen}
            onOpenChange={props.handleDrawerChange}
          >
            <p>To buy premium, go to www.experienceapp.io/premium</p>
            <button
              className="proceed-button"
              onClick={() => props.setDrawerOpen(false)}
            >
              Got it
            </button>
          </VaulDrawerShell>
        </div>
      </div>
    </div>
  );
};
